import styles from './FeaturesSection.module.css';
import contentStyles from './FeatureContents/FeatureContents.module.css';
import FeatureCard from '../../../../components/common/FeatureCard/FeatureCard';
import ScheduleContent from './FeatureContents/ScheduleContent';
import AuditionContent from './FeatureContents/AuditionContent';
import ActorDBContent from './FeatureContents/ActorDBContent';
import CommunicationContent from './FeatureContents/CommunicationContent';

const TABS = ['전체', '영화', '드라마', '광고'];

const auditionHeaderRight = (
  <div className={contentStyles.headerTabs}>
    {TABS.map((label, i) => (
      <span key={label} className={i === 0 ? contentStyles.headerTabActive : contentStyles.headerTab}>
        {label}
      </span>
    ))}
  </div>
);

const actorDBHeaderRight = (
  <div className={contentStyles.headerSearch}>
    <input
      className={contentStyles.headerSearchInput}
      placeholder="배우 검색"
      readOnly
    />
  </div>
);

/**
 * @component FeaturesGrid
 * @description 기능 카드 그리드
 */
function FeaturesGrid({ features, onCardClick }) {
  const contentComponents = {
    schedule: ScheduleContent,
    audition: AuditionContent,
    'actor-db': ActorDBContent,
    communication: CommunicationContent,
  };

  const headerRightMap = {
    audition: auditionHeaderRight,
    'actor-db': actorDBHeaderRight,
  };

  return (
    <div className={styles.featuresGrid}>
      {features.map((feature) => {
        const ContentComponent = contentComponents[feature.type];

        return (
          <FeatureCard
            key={feature.id}
            icon={feature.icon}
            title={feature.title}
            subtitle={feature.subtitle}
            active={feature.active}
            onClick={() => onCardClick && onCardClick(feature.id)}
            headerRight={headerRightMap[feature.type]}
            badge={feature.type === 'communication' ? 2 : undefined}
          >
            {ContentComponent && <ContentComponent />}
          </FeatureCard>
        );
      })}
    </div>
  );
}

export default FeaturesGrid;
